import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';

import { User, Company } from 'models';
import { connectMotion } from 'shared/kanimate';
import { StylePropType } from 'globals/styles';
import Avatar from 'shared/components/Avatar';

import { start, end, tween, staticStyles } from './styles';

import {
  getActiveSessionUsers,
  getCompany,
  getCompanyHistorySetting,
  hasChatSessions,
  selectIsAfterHours,
  selectActiveSessionWaitTime,
} from '../../app/ChatApp/selectors';
import * as helpers from './helpers';
import messages from './messages';

export class ChatConversationHeaderInfo extends PureComponent {
  renderAvatar() {
    const { sessionUsers, showMenu, company, styles, showOrgAvatar } = this.props;
    const user = sessionUsers.last();

    let name = company.name;
    let avatarUrl = company.avatarUrl;
    if (user && !showOrgAvatar) {
      name = user.name;
      avatarUrl = user.avatarUrl;
    }

    return (
      <div style={styles.avatar}>
        <Avatar avatarUrl={avatarUrl} defaultName={name} size={42} showUnread={showMenu} />
      </div>
    );
  }

  renderGreeting() {
    const { styles, isAfterHours, company, expanded } = this.props;
    if (!expanded && !isAfterHours && get(company, 'volumeControl.enabled')) return null;
    if (isAfterHours) {
      const afterHoursGreeting = company.get('offhoursMessage');
      return (
        <div
          title={afterHoursGreeting}
          style={expanded ? staticStyles.descriptionExpanded : styles.description}
          className="kustomer-app-header-after-hours-greeting"
        >
          {afterHoursGreeting}
        </div>
      );
    }
    const greeting = company.get('greeting');
    return (
      <div title={greeting} style={styles.description} className="kustomer-app-header-greeting">
        {greeting}
      </div>
    );
  }

  renderQueueTime() {
    const { queueTime } = this.props;

    if (queueTime === null) return null;

    const dayInSeconds = 86400;
    const hourInSeconds = 3600;
    const minuteInSeconds = 60;

    if (queueTime === 0) {
      return (
        <span style={staticStyles.waitMessage} className="kustomer-app-header-wait-message">
          <FormattedMessage {...messages.queue_waitTime_momentarily} />
        </span>
      );
    }

    if (queueTime > dayInSeconds) {
      return (
        <span style={staticStyles.waitMessage} className="kustomer-app-header-wait-message">
          <FormattedMessage {...messages.queue_waitTime__more_than_days} />
        </span>
      );
    }

    if (queueTime > hourInSeconds) {
      return (
        <span style={staticStyles.waitMessage} className="kustomer-app-header-wait-message">
          <FormattedMessage {...messages.queue_waitTime_hours} values={{ waitTime: Math.ceil(queueTime / 3600) }} />
        </span>
      );
    }

    if (queueTime > minuteInSeconds) {
      return (
        <span style={staticStyles.waitMessage} className="kustomer-app-header-wait-message">
          <FormattedMessage {...messages.queue_waitTime_minutes} values={{ waitTime: Math.ceil(queueTime / 60) }} />
        </span>
      );
    }

    return (
      <span style={staticStyles.waitMessage} className="kustomer-app-header-wait-message">
        <FormattedMessage {...messages.queue_waitTime_seconds} values={{ waitTime: Math.ceil(queueTime) }} />
      </span>
    );
  }

  renderWaitMessage() {
    const { company, company: { waitMessage }, expanded, isAfterHours, queueTime } = this.props;

    if (queueTime !== null) return null;

    const collapsedAndVCDisabled = !expanded && !get(company, 'volumeControl.enabled');
    const collapsedAndAfterHours = !expanded && isAfterHours;

    if (collapsedAndVCDisabled || collapsedAndAfterHours) return null;

    return (
      <span style={staticStyles.waitMessage} className="kustomer-app-header-wait-message">
        {waitMessage}
      </span>
    );
  }

  render() {
    const { styles, showMenu, sessionUsers, company, expanded, showOrgAvatar } = this.props;
    const name = helpers.getUserOrCompanyName(sessionUsers, company, showOrgAvatar);

    const wrapperStyles = Object.assign({}, styles.wrapper, !showMenu ? styles.noHistory : {});
    return (
      <div style={wrapperStyles}>
        {this.renderAvatar()}
        <div style={expanded ? staticStyles.infoWrapExpanded : styles.infoWrap}>
          <div style={styles.title} className="kustomer-app-header-title">
            {name}
          </div>
          {this.renderQueueTime()}
          {this.renderWaitMessage()}
          {this.renderGreeting()}
        </div>
      </div>
    );
  }
}

ChatConversationHeaderInfo.propTypes = {
  styles: StylePropType,
  sessionUsers: ImmutablePropTypes.listOf(React.PropTypes.instanceOf(User)),
  company: React.PropTypes.instanceOf(Company),
  expanded: React.PropTypes.bool,
  showOrgAvatar: React.PropTypes.bool,
  isAfterHours: React.PropTypes.bool,
  showMenu: React.PropTypes.bool,
  queueTime: React.PropTypes.number,
};

ChatConversationHeaderInfo.defaultProps = {
  sessionUsers: Immutable.List(),
  company: Company(),
  showOrgAvatar: false,
  showMenu: true,
  styles: {},
  queueTime: null,
};

const styleProps = {
  styles: staticStyles,
  start,
  end,
  tween,
};

const mapStateToProps = state => ({
  showMenu: hasChatSessions(state) && getCompanyHistorySetting(state),
  isAfterHours: selectIsAfterHours(state),
  sessionUsers: getActiveSessionUsers(state),
  queueTime: selectActiveSessionWaitTime(state),
  company: getCompany(state),
});

export const KAnimateChatConvoHeaderInfo = connectMotion(styleProps)(ChatConversationHeaderInfo);
export default connect(mapStateToProps)(KAnimateChatConvoHeaderInfo);
